import {PortfolioAssetsContext} from '#/components/portfolio/context/portfolio-assets-context';
import {minimumClaimableStableTokenAmount} from '#/utils/contract-consts';
import {useContext, useMemo} from 'react';
import {Land, LandAccountInfo} from 'shareland-common';

type UseClaimableLandContracts = {
  claimableLands: Land[];
  readyToClaimAmount: number;
  isLoading: boolean;
};

type LandGroup = {
  land: Land;
  landAccountInfo: LandAccountInfo;
};

export const usePortfolioClaimableLands = (): UseClaimableLandContracts => {
  const {landGroups, isLoading} = useContext(PortfolioAssetsContext);

  const landGroupsFiltered = landGroups
    .map(({land, landAccountInfo}) => ({
      land,
      landAccountInfo,
    }))
    .filter((entry): entry is LandGroup => !!entry.landAccountInfo)
    .filter(({landAccountInfo}) => landAccountInfo.claimableStableToken > minimumClaimableStableTokenAmount);

  const readyToClaimAmount = useMemo(
    () => landGroupsFiltered.reduce((acc, {landAccountInfo}) => acc + landAccountInfo.claimableStableToken, 0),
    [landGroupsFiltered],
  );

  return {
    claimableLands: landGroupsFiltered.map(({land}) => land),
    readyToClaimAmount,
    isLoading: isLoading.lands || isLoading.accountInfo,
  };
};
